export default __webpack_public_path__ + "static/media/circle-arrow-en.f01a3039.svg";